export enum FormatFilterOptionValue {
	FULL_TIME = "fulltime",
	PART_TIME = "parttime"
}
